'use client';

import { c as _c } from "react/compiler-runtime";
import { Footer as FooterComponent, FooterDesktopSectionContent, FooterMobileSectionContent } from 'design-system/client';
import { useTranslations, useLocale } from 'next-intl';
import { useMemo } from 'react';
import I18nHtml from '../I18nHtml';
import TextLink, { LocaleAwareLink } from '../TextLink';
import SectionContentPlaceholder from './SectionContentPlaceholder';
import useUserLinks from './useUserLinks';
import { ApiRouteNames, useApi } from '@/api';
import { RailsRoutes } from '@/helpers/utils';
import { locales } from '@/i18n';
import { localeTranslations } from '@/i18n/locales';
import { usePathname } from '@/i18n/navigation';
function useGetLocaleSwitchLinkLabel() {
  const otherLocale = useOtherLocale();
  return localeTranslations[otherLocale][otherLocale];
}
function useOtherLocale() {
  const $ = _c(2);
  const locale = useLocale();
  let t0;
  if ($[0] !== locale) {
    t0 = locales.find(l => l !== locale) ?? "de";
    $[0] = locale;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
function LocaleSwitchLink() {
  const $ = _c(4);
  const localeSwitchLinkLabel = useGetLocaleSwitchLinkLabel();
  const otherLocale = useOtherLocale();
  const pathname = usePathname();
  let t0;
  if ($[0] !== localeSwitchLinkLabel || $[1] !== otherLocale || $[2] !== pathname) {
    t0 = <LocaleAwareLink href={pathname} locale={otherLocale} lang={otherLocale}>{localeSwitchLinkLabel}</LocaleAwareLink>;
    $[0] = localeSwitchLinkLabel;
    $[1] = otherLocale;
    $[2] = pathname;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
}
function MobileContent(t0) {
  const $ = _c(3);
  const {
    isUserLoggedIn
  } = t0;
  const links = useUserLinks(isUserLoggedIn);
  if (isUserLoggedIn === undefined || isUserLoggedIn === null) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <SectionContentPlaceholder />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== links) {
    t1 = <FooterMobileSectionContent Link={TextLink} links={links} />;
    $[1] = links;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
function DesktopContent(t0) {
  const $ = _c(3);
  const {
    isUserLoggedIn
  } = t0;
  const links = useUserLinks(isUserLoggedIn);
  if (isUserLoggedIn === undefined || isUserLoggedIn === null) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <SectionContentPlaceholder />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== links) {
    t1 = <FooterDesktopSectionContent Link={TextLink} links={links} />;
    $[1] = links;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
function Footer() {
  const $ = _c(248);
  const t = useTranslations("nextjs");
  const locale = useLocale();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {};
    t1 = {
      pathNameOnly: true
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  const {
    data
  } = useApi(ApiRouteNames.apiCurrentUserLoggedIn, t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <I18nHtml i18nKey="footer.organisation_info.adwords_html" as="span" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const organizationInfoDetails = t2;
  data?.isValidSession;
  let t3;
  if ($[3] !== t) {
    t3 = t("footer.headline_1");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== locale) {
    t4 = RailsRoutes.aboutUs({
      locale
    });
    $[5] = locale;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t) {
    t5 = t("footer.what_is_betterplace");
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = {
      href: t4,
      children: t5,
      prefetch: false
    };
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== locale) {
    t7 = RailsRoutes.blog({
      locale
    });
    $[12] = locale;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = t("footer.blog");
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t7 || $[17] !== t8) {
    t9 = {
      href: t7,
      children: t8,
      prefetch: false
    };
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      href: RailsRoutes.aboutUsAcademy({
        utm_source: "footer",
        utm_medium: "bp_footer",
        utm_campaign: "bp-org_page"
      }),
      children: "betterplace academy",
      prefetch: false
    };
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== locale) {
    t11 = RailsRoutes.team({
      locale
    });
    $[20] = locale;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t) {
    t12 = t("footer.team");
    $[22] = t;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t11 || $[25] !== t12) {
    t13 = {
      href: t11,
      children: t12,
      prefetch: false
    };
    $[24] = t11;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== locale) {
    t14 = RailsRoutes.jobs({
      locale
    });
    $[27] = locale;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t) {
    t15 = t("footer.jobs");
    $[29] = t;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t14 || $[32] !== t15) {
    t16 = {
      href: t14,
      children: t15,
      prefetch: false
    };
    $[31] = t14;
    $[32] = t15;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== locale) {
    t17 = RailsRoutes.press({
      locale
    });
    $[34] = locale;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t) {
    t18 = t("footer.press");
    $[36] = t;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== t17 || $[39] !== t18) {
    t19 = {
      href: t17,
      children: t18,
      prefetch: false
    };
    $[38] = t17;
    $[39] = t18;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== locale) {
    t20 = RailsRoutes.contactUs({
      locale
    });
    $[41] = locale;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== t) {
    t21 = t("footer.contact");
    $[43] = t;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] !== t20 || $[46] !== t21) {
    t22 = {
      href: t20,
      children: t21,
      prefetch: false
    };
    $[45] = t20;
    $[46] = t21;
    $[47] = t22;
  } else {
    t22 = $[47];
  }
  let t23;
  if ($[48] !== t) {
    t23 = t("external_links.a11y_statement.url");
    $[48] = t;
    $[49] = t23;
  } else {
    t23 = $[49];
  }
  let t24;
  if ($[50] !== t) {
    t24 = t("external_links.a11y_statement.content");
    $[50] = t;
    $[51] = t24;
  } else {
    t24 = $[51];
  }
  let t25;
  if ($[52] !== t23 || $[53] !== t24) {
    t25 = {
      href: t23,
      children: t24,
      external: true
    };
    $[52] = t23;
    $[53] = t24;
    $[54] = t25;
  } else {
    t25 = $[54];
  }
  let t26;
  if ($[55] !== t) {
    t26 = t("external_links.api.url");
    $[55] = t;
    $[56] = t26;
  } else {
    t26 = $[56];
  }
  let t27;
  if ($[57] !== t) {
    t27 = t("external_links.api.content");
    $[57] = t;
    $[58] = t27;
  } else {
    t27 = $[58];
  }
  let t28;
  if ($[59] !== t26 || $[60] !== t27) {
    t28 = {
      href: t26,
      children: t27,
      external: true
    };
    $[59] = t26;
    $[60] = t27;
    $[61] = t28;
  } else {
    t28 = $[61];
  }
  let t29;
  if ($[62] !== t13 || $[63] !== t16 || $[64] !== t19 || $[65] !== t22 || $[66] !== t25 || $[67] !== t28 || $[68] !== t6 || $[69] !== t9) {
    t29 = [t6, t9, t10, t13, t16, t19, t22, t25, t28].filter(_temp);
    $[62] = t13;
    $[63] = t16;
    $[64] = t19;
    $[65] = t22;
    $[66] = t25;
    $[67] = t28;
    $[68] = t6;
    $[69] = t9;
    $[70] = t29;
  } else {
    t29 = $[70];
  }
  let t30;
  if ($[71] !== t29 || $[72] !== t3) {
    t30 = {
      column: 1,
      title: t3,
      links: t29
    };
    $[71] = t29;
    $[72] = t3;
    $[73] = t30;
  } else {
    t30 = $[73];
  }
  let t31;
  if ($[74] !== t) {
    t31 = t("footer.headline_2");
    $[74] = t;
    $[75] = t31;
  } else {
    t31 = $[75];
  }
  let t32;
  if ($[76] !== locale) {
    t32 = RailsRoutes.collectAsOrganisation({
      locale
    });
    $[76] = locale;
    $[77] = t32;
  } else {
    t32 = $[77];
  }
  let t33;
  if ($[78] !== t) {
    t33 = t("footer.landingpage_fundraising");
    $[78] = t;
    $[79] = t33;
  } else {
    t33 = $[79];
  }
  let t34;
  if ($[80] !== t32 || $[81] !== t33) {
    t34 = {
      href: t32,
      children: t33,
      prefetch: false
    };
    $[80] = t32;
    $[81] = t33;
    $[82] = t34;
  } else {
    t34 = $[82];
  }
  let t35;
  if ($[83] !== locale) {
    t35 = RailsRoutes.collectAsPrivatePersonAction({
      locale
    });
    $[83] = locale;
    $[84] = t35;
  } else {
    t35 = $[84];
  }
  let t36;
  if ($[85] !== t) {
    t36 = t("footer.landingpage_fundraising_event");
    $[85] = t;
    $[86] = t36;
  } else {
    t36 = $[86];
  }
  let t37;
  if ($[87] !== t35 || $[88] !== t36) {
    t37 = {
      href: t35,
      children: t36,
      prefetch: false
    };
    $[87] = t35;
    $[88] = t36;
    $[89] = t37;
  } else {
    t37 = $[89];
  }
  let t38;
  if ($[90] !== locale || $[91] !== t) {
    t38 = locale === "de" ? {
      href: RailsRoutes.collectAsPrivatePersonFundraising({
        locale
      }),
      children: t("footer.landingpage_fundraising_appeal"),
      prefetch: false
    } : null;
    $[90] = locale;
    $[91] = t;
    $[92] = t38;
  } else {
    t38 = $[92];
  }
  let t39;
  if ($[93] !== locale) {
    t39 = RailsRoutes.collectAsCompany({
      locale
    });
    $[93] = locale;
    $[94] = t39;
  } else {
    t39 = $[94];
  }
  let t40;
  if ($[95] !== t) {
    t40 = t("footer.as_a_company");
    $[95] = t;
    $[96] = t40;
  } else {
    t40 = $[96];
  }
  let t41;
  if ($[97] !== t39 || $[98] !== t40) {
    t41 = {
      href: t39,
      children: t40,
      prefetch: false
    };
    $[97] = t39;
    $[98] = t40;
    $[99] = t41;
  } else {
    t41 = $[99];
  }
  let t42;
  if ($[100] !== locale || $[101] !== t) {
    t42 = locale === "de" ? [{
      href: RailsRoutes.collectAsStreamer({}),
      children: t("footer.as_a_streamer"),
      prefetch: false
    }, {
      href: RailsRoutes.collectAsContentCreator({}),
      children: t("footer.as_a_content_creator"),
      prefetch: false
    }] : [];
    $[100] = locale;
    $[101] = t;
    $[102] = t42;
  } else {
    t42 = $[102];
  }
  let t43;
  if ($[103] !== t34 || $[104] !== t37 || $[105] !== t38 || $[106] !== t41 || $[107] !== t42) {
    t43 = [t34, t37, t38, t41, ...t42].filter(_temp2);
    $[103] = t34;
    $[104] = t37;
    $[105] = t38;
    $[106] = t41;
    $[107] = t42;
    $[108] = t43;
  } else {
    t43 = $[108];
  }
  let t44;
  if ($[109] !== t31 || $[110] !== t43) {
    t44 = {
      column: 2,
      title: t31,
      links: t43
    };
    $[109] = t31;
    $[110] = t43;
    $[111] = t44;
  } else {
    t44 = $[111];
  }
  let t45;
  if ($[112] !== t) {
    t45 = t("footer.headline_3");
    $[112] = t;
    $[113] = t45;
  } else {
    t45 = $[113];
  }
  let t46;
  if ($[114] !== locale) {
    t46 = RailsRoutes.discovery({
      locale
    });
    $[114] = locale;
    $[115] = t46;
  } else {
    t46 = $[115];
  }
  let t47;
  if ($[116] !== t) {
    t47 = t("footer.project_search");
    $[116] = t;
    $[117] = t47;
  } else {
    t47 = $[117];
  }
  let t48;
  if ($[118] !== t46 || $[119] !== t47) {
    t48 = {
      href: t46,
      children: t47,
      prefetch: false
    };
    $[118] = t46;
    $[119] = t47;
    $[120] = t48;
  } else {
    t48 = $[120];
  }
  let t49;
  if ($[121] !== locale) {
    t49 = RailsRoutes.popularProjects({
      locale
    });
    $[121] = locale;
    $[122] = t49;
  } else {
    t49 = $[122];
  }
  let t50;
  if ($[123] !== t) {
    t50 = t("footer.popular_projects");
    $[123] = t;
    $[124] = t50;
  } else {
    t50 = $[124];
  }
  let t51;
  if ($[125] !== t49 || $[126] !== t50) {
    t51 = {
      href: t49,
      children: t50,
      prefetch: false
    };
    $[125] = t49;
    $[126] = t50;
    $[127] = t51;
  } else {
    t51 = $[127];
  }
  let t52;
  if ($[128] !== locale) {
    t52 = RailsRoutes.donateToBetterplace({
      locale
    });
    $[128] = locale;
    $[129] = t52;
  } else {
    t52 = $[129];
  }
  let t53;
  if ($[130] !== t) {
    t53 = t("footer.donate_to_betterplace");
    $[130] = t;
    $[131] = t53;
  } else {
    t53 = $[131];
  }
  let t54;
  if ($[132] !== t52 || $[133] !== t53) {
    t54 = {
      href: t52,
      children: t53,
      prefetch: false
    };
    $[132] = t52;
    $[133] = t53;
    $[134] = t54;
  } else {
    t54 = $[134];
  }
  let t55;
  if ($[135] !== t48 || $[136] !== t51 || $[137] !== t54) {
    t55 = [t48, t51, t54].filter(_temp3);
    $[135] = t48;
    $[136] = t51;
    $[137] = t54;
    $[138] = t55;
  } else {
    t55 = $[138];
  }
  let t56;
  if ($[139] !== t45 || $[140] !== t55) {
    t56 = {
      column: 3,
      title: t45,
      links: t55
    };
    $[139] = t45;
    $[140] = t55;
    $[141] = t56;
  } else {
    t56 = $[141];
  }
  let t57;
  if ($[142] !== t) {
    t57 = t("footer.headline_4");
    $[142] = t;
    $[143] = t57;
  } else {
    t57 = $[143];
  }
  const t58 = data?.isValidSession;
  let t59;
  if ($[144] !== t58) {
    t59 = <MobileContent isUserLoggedIn={t58} />;
    $[144] = t58;
    $[145] = t59;
  } else {
    t59 = $[145];
  }
  const t60 = data?.isValidSession;
  let t61;
  if ($[146] !== t60) {
    t61 = <DesktopContent isUserLoggedIn={t60} />;
    $[146] = t60;
    $[147] = t61;
  } else {
    t61 = $[147];
  }
  let t62;
  if ($[148] === Symbol.for("react.memo_cache_sentinel")) {
    t62 = [];
    $[148] = t62;
  } else {
    t62 = $[148];
  }
  let t63;
  if ($[149] !== t57 || $[150] !== t59 || $[151] !== t61) {
    t63 = {
      column: 3,
      title: t57,
      mobile: t59,
      desktop: t61,
      links: t62
    };
    $[149] = t57;
    $[150] = t59;
    $[151] = t61;
    $[152] = t63;
  } else {
    t63 = $[152];
  }
  let t64;
  if ($[153] !== t) {
    t64 = t("footer.headline_5");
    $[153] = t;
    $[154] = t64;
  } else {
    t64 = $[154];
  }
  let t65;
  if ($[155] !== t) {
    t65 = t("external_links.help.url");
    $[155] = t;
    $[156] = t65;
  } else {
    t65 = $[156];
  }
  let t66;
  if ($[157] !== t) {
    t66 = t("footer.help");
    $[157] = t;
    $[158] = t66;
  } else {
    t66 = $[158];
  }
  let t67;
  if ($[159] !== t65 || $[160] !== t66) {
    t67 = {
      href: t65,
      children: t66,
      external: true
    };
    $[159] = t65;
    $[160] = t66;
    $[161] = t67;
  } else {
    t67 = $[161];
  }
  let t68;
  if ($[162] !== locale) {
    t68 = RailsRoutes.legal({
      locale
    });
    $[162] = locale;
    $[163] = t68;
  } else {
    t68 = $[163];
  }
  let t69;
  if ($[164] !== t) {
    t69 = t("footer.legal");
    $[164] = t;
    $[165] = t69;
  } else {
    t69 = $[165];
  }
  let t70;
  if ($[166] !== t68 || $[167] !== t69) {
    t70 = {
      href: t68,
      children: t69,
      prefetch: false
    };
    $[166] = t68;
    $[167] = t69;
    $[168] = t70;
  } else {
    t70 = $[168];
  }
  let t71;
  if ($[169] !== locale || $[170] !== t) {
    t71 = locale === "de" ? {
      href: t("external_links.charity_streams_dos_and_donts.url"),
      children: t("footer.charity_streams_dos_and_donts"),
      external: true
    } : null;
    $[169] = locale;
    $[170] = t;
    $[171] = t71;
  } else {
    t71 = $[171];
  }
  let t72;
  if ($[172] !== locale) {
    t72 = RailsRoutes.donationGift({
      locale
    });
    $[172] = locale;
    $[173] = t72;
  } else {
    t72 = $[173];
  }
  let t73;
  if ($[174] !== t) {
    t73 = t("footer.donation_gift");
    $[174] = t;
    $[175] = t73;
  } else {
    t73 = $[175];
  }
  let t74;
  if ($[176] !== t72 || $[177] !== t73) {
    t74 = {
      href: t72,
      children: t73,
      prefetch: false
    };
    $[176] = t72;
    $[177] = t73;
    $[178] = t74;
  } else {
    t74 = $[178];
  }
  let t75;
  if ($[179] !== t67 || $[180] !== t70 || $[181] !== t71 || $[182] !== t74) {
    t75 = [t67, t70, t71, t74].filter(_temp4);
    $[179] = t67;
    $[180] = t70;
    $[181] = t71;
    $[182] = t74;
    $[183] = t75;
  } else {
    t75 = $[183];
  }
  let t76;
  if ($[184] !== t64 || $[185] !== t75) {
    t76 = {
      column: 4,
      title: t64,
      links: t75
    };
    $[184] = t64;
    $[185] = t75;
    $[186] = t76;
  } else {
    t76 = $[186];
  }
  let t77;
  if ($[187] !== t30 || $[188] !== t44 || $[189] !== t56 || $[190] !== t63 || $[191] !== t76) {
    t77 = [t30, t44, t56, t63, t76];
    $[187] = t30;
    $[188] = t44;
    $[189] = t56;
    $[190] = t63;
    $[191] = t76;
    $[192] = t77;
  } else {
    t77 = $[192];
  }
  const sections = t77;
  let t78;
  if ($[193] === Symbol.for("react.memo_cache_sentinel")) {
    t78 = <LocaleSwitchLink />;
    $[193] = t78;
  } else {
    t78 = $[193];
  }
  let t79;
  if ($[194] !== t) {
    t79 = t("footer.organisation_info.claim");
    $[194] = t;
    $[195] = t79;
  } else {
    t79 = $[195];
  }
  let t80;
  if ($[196] !== t) {
    t80 = t("footer.cookie_banner_link");
    $[196] = t;
    $[197] = t80;
  } else {
    t80 = $[197];
  }
  let t81;
  if ($[198] !== t) {
    t81 = t("footer.headline_5");
    $[198] = t;
    $[199] = t81;
  } else {
    t81 = $[199];
  }
  let t82;
  if ($[200] !== t80 || $[201] !== t81) {
    t82 = {
      label: t80,
      section: t81
    };
    $[200] = t80;
    $[201] = t81;
    $[202] = t82;
  } else {
    t82 = $[202];
  }
  let t83;
  if ($[203] === Symbol.for("react.memo_cache_sentinel")) {
    t83 = RailsRoutes.itz({});
    $[203] = t83;
  } else {
    t83 = $[203];
  }
  let t84;
  if ($[204] !== t) {
    t84 = t("footer.itz_logo_alt_text");
    $[204] = t;
    $[205] = t84;
  } else {
    t84 = $[205];
  }
  let t85;
  if ($[206] !== t84) {
    t85 = {
      href: t83,
      label: t84
    };
    $[206] = t84;
    $[207] = t85;
  } else {
    t85 = $[207];
  }
  let t86;
  if ($[208] !== t) {
    t86 = t("external_links.facebook_page.url");
    $[208] = t;
    $[209] = t86;
  } else {
    t86 = $[209];
  }
  let t87;
  if ($[210] !== t) {
    t87 = t("external_links.facebook_page.content");
    $[210] = t;
    $[211] = t87;
  } else {
    t87 = $[211];
  }
  let t88;
  if ($[212] !== t86 || $[213] !== t87) {
    t88 = {
      href: t86,
      label: t87
    };
    $[212] = t86;
    $[213] = t87;
    $[214] = t88;
  } else {
    t88 = $[214];
  }
  let t89;
  if ($[215] !== t) {
    t89 = t("external_links.instagram_profile.url");
    $[215] = t;
    $[216] = t89;
  } else {
    t89 = $[216];
  }
  let t90;
  if ($[217] !== t) {
    t90 = t("external_links.instagram_profile.content");
    $[217] = t;
    $[218] = t90;
  } else {
    t90 = $[218];
  }
  let t91;
  if ($[219] !== t89 || $[220] !== t90) {
    t91 = {
      href: t89,
      label: t90
    };
    $[219] = t89;
    $[220] = t90;
    $[221] = t91;
  } else {
    t91 = $[221];
  }
  let t92;
  if ($[222] !== t) {
    t92 = t("external_links.linkedin_profile.url");
    $[222] = t;
    $[223] = t92;
  } else {
    t92 = $[223];
  }
  let t93;
  if ($[224] !== t) {
    t93 = t("external_links.linkedin_profile.content");
    $[224] = t;
    $[225] = t93;
  } else {
    t93 = $[225];
  }
  let t94;
  if ($[226] !== t92 || $[227] !== t93) {
    t94 = {
      href: t92,
      label: t93
    };
    $[226] = t92;
    $[227] = t93;
    $[228] = t94;
  } else {
    t94 = $[228];
  }
  let t95;
  if ($[229] !== t) {
    t95 = t("external_links.tax_receipt_hint_link.url");
    $[229] = t;
    $[230] = t95;
  } else {
    t95 = $[230];
  }
  let t96;
  if ($[231] !== t) {
    t96 = t("external_links.tax_receipt_hint_link.content");
    $[231] = t;
    $[232] = t96;
  } else {
    t96 = $[232];
  }
  let t97;
  if ($[233] !== t) {
    t97 = t("footer.tax_receipt_hint", {
      tax_receipt_year: "0000",
      tax_receipt_processed_at_year: "0001"
    });
    $[233] = t;
    $[234] = t97;
  } else {
    t97 = $[234];
  }
  let t98;
  if ($[235] !== t95 || $[236] !== t96 || $[237] !== t97) {
    t98 = {
      href: t95,
      label: t96,
      children: t97
    };
    $[235] = t95;
    $[236] = t96;
    $[237] = t97;
    $[238] = t98;
  } else {
    t98 = $[238];
  }
  let t99;
  if ($[239] !== sections || $[240] !== t79 || $[241] !== t82 || $[242] !== t85 || $[243] !== t88 || $[244] !== t91 || $[245] !== t94 || $[246] !== t98) {
    t99 = <FooterComponent Link={TextLink} localeSwitchLink={t78} text={{
      organizationInfo: t79,
      organizationInfoDetails,
      cookieSettingsLink: t82,
      transparentCivilSocietyLink: t85,
      facebookLink: t88,
      instagramLink: t91,
      linkedinLink: t94,
      taxReceiptHint: t98,
      sections
    }} />;
    $[239] = sections;
    $[240] = t79;
    $[241] = t82;
    $[242] = t85;
    $[243] = t88;
    $[244] = t91;
    $[245] = t94;
    $[246] = t98;
    $[247] = t99;
  } else {
    t99 = $[247];
  }
  return t99;
}
function _temp4(link_2) {
  return !!link_2;
}
function _temp3(link_1) {
  return !!link_1;
}
function _temp2(link_0) {
  return !!link_0;
}
function _temp(link) {
  return !!link;
}
export default Footer;